<template>
  <div class="userInformation">
    <p>
      按个摩将尽全力保护您的个人安全，并保障您在个人信息处理过程中的相关权益。为了向您提供按个摩的基本功能及附加功能，我们需要收集您在使用服务时通过您主动授权/提供等方式产生的个人信息。以下我们将逐一说明收集情况，方便您快速查阅。
    </p>

    <div class="box">
      <div class="line" @click="go(1)">
        <label>用户基本信息</label>
      </div>
      <div class="line" @click="go(2)">
        <label>用户身份信息</label>
      </div>
      <div class="line" @click="go(3)">
        <label>账户信息</label>
      </div>
      <div class="line" @click="go(4)">
        <label>位置信息</label>
      </div>
      <div class="line" @click="go(5)">
        <label>设备信息</label>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      result: 0,
    };
  },
  mounted() {},
  methods: {
    go(type) {
      this.$router.push({
        path: "/information?type="+type,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import url("../assets/style/rem.css");
.userInformation {
  background: #f8f8f8;
  min-height: 100vh;
  box-sizing: border-box;
  padding: 0.3rem;

  p {
    margin-bottom: 0.3rem;
  }
  .box {
    background: #fff;

    .line {
      height: 1rem;
      display: flex;
      align-items: center;
      padding: 0 0.3rem;
      border-bottom: 1px solid #eee;

      &:last-child {
        border: none;
      }

      label {
        flex: 1;
      }

      &::after {
        content: "";
        width: 0.14rem;
        height: 0.24rem;
        background: url("../assets/image/arrow.png") no-repeat;
        background-size: 100% auto;
      }
    }
  }
}
</style>